import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";
import TextInputCustom from '../PushInteractive/CustomTextInput'
import ComboboxInput from "../PushInteractive/ComboboxInputCustom";
import ActionAdd from '../../store/action/DivisionSetting/Add'
import ActionEdit from '../../store/action/DivisionSetting/Edit'
import { IsEdit, IsCreate, IsView } from '../../store/constants'
import ActionGetAllClient from "../../store/action/Client/FetchAll";
class Form extends Component {

    constructor(props) {
        super(props);
        this.state = {
            form: fromJS({
                'client-id': '',
                'division-name': '',
                'division-id':''
            }),
            disabled: false,
            errors: fromJS({}),
            error: '',
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        this.props.actionGetAllClient();
    }

    handleChange(field, value) {
        var formVal = this.state.form;
        formVal = formVal.set(field, value);
        //debugger
        this.setState({ form: formVal })
    }
    async handleSubmit(dispatch) {

        const form = this.state.form;

        if (form.get('client-id') == '' || form.get('client-id') == null || form.get('client-id') == undefined) {
            this.setState({ error: "Client cannot be empty!" });
            toast.error('Clienat cannot be empty!', toast.POSITION.TOP_RIGHT);

            return false;
        }

        if (form.get('division-name') == '' || form.get('division-name') == null || form.get('division-name') == undefined) {
            this.setState({ error: "Division name cannot be empty!" });
            toast.error('Division name cannot be empty!', toast.POSITION.TOP_RIGHT);

            return false;
        }
        switch (this.props.actionType) {
            case IsCreate:
                await this.SubmitNewData();
                break;
            case IsEdit:
                await this.SubmitEditData();
                break;
            default:
            // code block
        }


    }

    async SubmitNewData() {
        const form = this.state.form;
        var data =
        {
            'data':
            {
                'client-id': form.get('client-id'),
                'division-name': form.get('division-name'),

            }
        };

        var response = await this.props.actionAdd(data);
        if (response.ok) {
            toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
            this.props.handleCancelForm(true);
        } else {
            toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
        }
    }

    async SubmitEditData() {
        const form = this.state.form;
        var data =
        {
            'data':
            {
                'client-id': form.get('client-id'),
                'division-name': form.get('division-name'),
                'division-id':form.get('division-id')
            }
        };

        var response = await this.props.actionEdit(data);
        if (response.ok) {
            toast.success('Edit Success!', toast.POSITION.TOP_RIGHT);
            this.props.handleCancelForm(true);
        } else {
            toast.error('Edit Failed', toast.POSITION.TOP_RIGHT);
        }
    }

    handleCancel() {
        this.props.handleCancelForm(false);
    }

    componentWillMount() {
        if (this.props.item != null || this.props.item !== undefined) {
            if ((this.props.actionType === IsView || this.props.actionType === IsEdit) && !this.state.loadded) {
                this.setState({
                    form: fromJS({
                        'client-id': this.props.item.get('client-id'),
                        'division-name': this.props.item.get('division-name'),
                        'division-id':this.props.item.get('division-id')
                    }),
                    loadded: true,
                    disabled: (this.props.actionType === IsView),
                })
            }
        }
    }

    render() {
        const { form, errors, disabled } = this.state;
        return (
            <div className="card no-margin-bottom">
                <div className="body">
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Client</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='client-id'
                                value={form.get('client-id')}
                                options={fromJS({
                                    'source': this.props.clientall,
                                    'value': 'client-id',
                                    'label': 'client-name'
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="Client"
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Division</span>
                        <div className="col-sm-10">
                            <TextInputCustom
                                field={'division-name'}
                                value={form.get('division-name')}
                                onChange={(field, value) => this.handleChange(field, value)}
                                placeholder="Division Name"
                            />
                        </div>
                    </div>

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2"></span>
                        <div className="col-sm-10">
                            <button type="button"
                                className="btn btn-wide btn-danger"
                                value="Cancel"
                                onClick={this.handleCancel}>
                                Cancel
                            </button>
                            <button type="button"
                                className="btn btn-wide btn-success"
                                onClick={this.handleSubmit}>
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default connect(
    (state) => {
        return {
            clientall: state.user.clientall,
        }
    },
    dispatch => bindActionCreators({
        actionAdd: ActionAdd,
        actionGetAllClient: ActionGetAllClient,
        actionEdit: ActionEdit,

    }, dispatch),
)(Form);